<my-bill-odb-page-base-structure
  [hasCustomHeader]="true"
  [leftColumnClassWidth]="'medium-8'"
  [rightColumnClassWidth]="'medium-4'"
>
  <my-bill-overview-header
    [mainTitle]="mainTitle"
    [subtitle]="subtitle"
    customHeader
  ></my-bill-overview-header>

  <ng-container leftColumnContent>
    <div
      class="rs-panel-big rs-bg-c2 rs-margin-bottom4-m clearfix"
      data-cy="instalmentPlanLeftPartOne"
    >
      <p class="rs-tit3">
        {{ 'bills.instalment.detailsPage.anActiveInstalmentPlan' | translate }}
      </p>
      <my-bill-instalment-plan-progress-bar
        [instalmentPlanInformation]="instalmentPlanInformation"
      ></my-bill-instalment-plan-progress-bar>
      <hr />
      <div
        *ngFor="let sliceDetail of instalmentPlanInformation?.sliceDetails"
        class="rs-flex-row rs-flex-collapse rs-flex-dir-col-small-only"
        data-cy="instalmentPlanSliceDetail"
      >
        <div class="rs-flex-column rs-flex-shrink">
          <p
            class="rs-padding-bottom1-so"
            data-cy="instalmentPlanSliceNumberLabel"
          >
            {{ 'bills.instalment.detailsPage.sliceNumberLabel' | translate }}
            {{ sliceDetail.number }}:
          </p>
        </div>
        <div class="rs-flex-column">
          <div class="rs-flex-row">
            <div class="rs-flex-column">
              <ng-container [ngSwitch]="sliceDetail.status">
                <ng-container *ngSwitchCase="'OPEN'">
                  <span
                    class="rs-txt-primary rs-margin-left1-m"
                    data-cy="instalmentPlanSliceStatusOpen"
                    >{{
                      'bills.instalment.detailsPage.sliceStatusLabel.OPEN'
                        | translate
                    }}
                    {{ getMonthTranslation(sliceDetail.dueDate) }}</span
                  >
                </ng-container>
                <ng-container *ngSwitchCase="'OVERDUE'">
                  <p
                    class="rs-status rs-error rs-margin-left1-m"
                    data-cy="instalmentPlanSliceStatusOverdue"
                  >
                    <i class="rs-status-icon" aria-hidden="true"></i
                    >{{ getMonthTranslation(sliceDetail.dueDate) }}
                    {{
                      'bills.instalment.detailsPage.sliceStatusLabel.OVERDUE'
                        | translate
                    }}
                  </p>
                </ng-container>
                <ng-container *ngSwitchCase="'PAID'">
                  <p
                    class="rs-status rs-success rs-margin-left1-m"
                    data-cy="instalmentPlanSliceStatusPaid"
                  >
                    <i class="rs-status-icon" aria-hidden="true"></i
                    >{{ getMonthTranslation(sliceDetail.dueDate) }}
                    {{
                      'bills.instalment.detailsPage.sliceStatusLabel.PAID'
                        | translate
                    }}
                  </p>
                </ng-container>
              </ng-container>
            </div>
            <div class="rs-flex-column rs-flex-shrink">
              <p class="rs-font-pxB">
                <px-currency-amount
                  [amount]="sliceDetail.totalAmount"
                ></px-currency-amount>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="rs-panel-big rs-bg-c2 clearfix"
      data-cy="instalmentPlanLeftPartTwo"
    >
      <p class="rs-tit4">
        {{ concernedBillsKey | translate }}
      </p>
      <my-bill-transaction-card
        *ngFor="let billingDocument of billingDocuments"
        [balance]="billingDocument.balance"
        [billingAccount]="billingAccount"
        [billingDocument]="billingDocument"
      >
      </my-bill-transaction-card>
    </div>
  </ng-container>
  <ng-container rightColumnContent>
    <div class="rs-panel-big rs-bg-c2 clearfix">
      <my-bill-faq-settings-container
        [zone]="'mybill.instalment.plan.details'"
        [isResUser]="isResUser"
      ></my-bill-faq-settings-container>
    </div>
  </ng-container>
</my-bill-odb-page-base-structure>
